<template>
  <div class="home">
    <header>
      <div class="logo">
        <img src="@/assets/logo.png" alt=""/>
        <h1>企企冰管理系统</h1>
      </div>

      <div class="right">
        <div class="notice" style="font-size: 0">
          <router-link to="/config">
            <i style="font-size: 26px" class="iconfont icon-shezhi"></i>
          </router-link>
        </div>

        <el-dropdown>
          <div class="user">
            <div class="text">
              <div class="name">admin</div>
              <div class="card">超级管理员</div>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="outLogin">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div
            class="menu_box"
            :class="menuStatus ? 'menu_show' : ''"
            @click="menu_click"
        >
          <div class="line"></div>
        </div>
      </div>
    </header>
    <div class="container">
      <nav :class="menuStatus ? 'navShow' : ''">
        <ul class="nav">
          <li>
            <router-link to="/homes">
              <i class="iconfont icon-shouye"></i>
              <span>首页</span>
            </router-link>
          </li>
          <li>
            <router-link to="/cashier">
              <i class="iconfont icon-shouyinji"></i>
              <span>收银系统</span>
            </router-link>
          </li>
          <li>
            <router-link to="/user">
              <i class="iconfont icon-yonghuguanli_huaban"></i>
              <span>用户管理</span>
            </router-link>
          </li>
          <li class="son">
            <a>
              <!-- <router-link to="/online/commodity/classify"> -->
              <i class="iconfont icon-diandan"></i>
              <span>点单商品</span>
              <!-- </router-link> -->
            </a>
            <div class="sonNav">
              <ul>
                <li>
                  <router-link to="/online/commodity/classify">
                    <span>点单分类</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/online/commodity/products">
                    <span>点单商品</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/online/commodity/site">
                    <span>配送站点</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <router-link to="/banner">
              <i class="iconfont icon-lunbotuguanli"></i>
              <span>首页轮播图</span>
            </router-link>
          </li>
          <li>
            <router-link to="/vip">
              <i class="iconfont icon-tongzhizhongxin"></i>
              <span>充值配置</span>
            </router-link>
          </li>
<!--          <li>-->
<!--            <router-link to="/agentOrder">-->
<!--              <i class="iconfont icon-tongzhizhongxin"></i>-->
<!--              <span>结算</span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <router-link to="/lottery">-->
<!--              <i class="iconfont icon-tongzhizhongxin"></i>-->
<!--              <span>抽奖配置</span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <router-link to="/notice">-->
<!--              <i class="iconfont icon-tongzhizhongxin"></i>-->
<!--              <span>通知公告</span>-->
<!--            </router-link>-->
<!--          </li>-->
          <li>
            <router-link to="/order">
              <i class="iconfont icon-dingdan"></i>
              <span>订单管理</span>
            </router-link>
          </li>
          <li class="son">
            <a>
              <!-- <router-link to="/commodity/classify"> -->
              <i class="iconfont icon-shouhoufuwu"></i>
              <span>聚合商品</span>
              <!-- </router-link> -->
            </a>
            <div class="sonNav">
              <ul>
                <li>
                  <router-link to="/commodity/classify">
                    <span>商品分类</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/commodity/products">
                    <span>商品管理</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <router-link to="/config">
              <i class="iconfont icon-shezhi"></i>
              <span>系统设置</span>
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="container_box">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";

const router = useRouter();

import {ref, reactive, onMounted, watch} from "vue";

import {ElMessage, ElIcon} from "element-plus";
import {BellFilled} from "@element-plus/icons-vue";

import {useRoute, onBeforeRouteUpdate} from "vue-router";

const route = useRoute();

let menuStatus = ref(false);

// 监听路由变化
watch(
    () => route.path,
    (newPath, oldPath) => {
      menuStatus.value = false;
    }
);

// 点击menu按钮
function menu_click() {
  menuStatus.value = !menuStatus.value;
  console.log(menuStatus.value);
}

// 验证登录状态
function isLogin() {
  const token = localStorage.getItem("token");
  if (!token) {
    router.push("/login");
  }
}

// 退出登录
function outLogin() {
  localStorage.removeItem("token");
  router.push("/login");
}

/**
 * 初始页面
 */
onMounted(() => {
  isLogin();
});
</script>

<style lang="less" scoped>
.home {
  background-color: #eff1f3;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  header {
    background-color: #fff;
    padding: 10px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      font-size: 0;
      display: flex;
      align-items: center;

      h1 {
        font-size: 26px;
        padding-left: 5px;
        font-weight: bold;
        color: #000;
      }

      img {
        width: 45px;
        border-radius: 100%;
      }
    }

    .right {
      display: flex;
      align-items: center;

      .menu_box {
        display: none;
        width: 24px;
        height: 16px;
        align-items: center;
        margin-left: 15px;
        justify-content: space-between;
        flex-direction: column;
        position: relative;

        &::after,
        &::before,
        .line {
          content: "";
          width: 100%;
          height: 2px;
          background-color: #000;
          border-radius: 10px;
          transform-origin: center center;
        }

        &.menu_show {
          height: 24px;

          .line {
            opacity: 0;
            position: absolute;
          }

          &::after {
            transform: rotate(45deg) translateY(-50%);
          }

          &::before {
            transform: rotate(-45deg) translateY(-50%);
          }

          &::after,
          &::before {
            position: absolute;
            left: 0;
            top: 50%;
          }
        }
      }

      .notice {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        font-size: 22px;
      }

      .number {
        position: absolute;
        width: 6px;
        right: 0;
        top: 0;
        height: 6px;
        background-color: red;
        border-radius: 100%;
      }

      .user {
        display: flex;
        align-items: center;
        margin-left: 35px;
        cursor: pointer;

        &::after {
          content: "";
          border: 5px solid transparent;
          border-top-color: #000;
          margin-left: 25px;
        }

        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 100%;
          background-color: #08c9a7;
        }

        .text {
          padding-left: 10px;

          .name {
            font-weight: bold;
            font-size: 20px;
          }

          .card {
            margin-top: 3px;
            font-size: 11px;
            padding: 3px 5px;
            line-height: 1;
            background-color: #f3f6fb;
            color: #59abc7;
            border: 1px solid #98cee0;
            border-radius: 5px;
          }
        }
      }
    }
  }

  .container {
    flex: 1;
    padding: 10px;
    display: flex;
    overflow: hidden;

    nav {
      border-radius: 8px;
      background-color: #fff;
      padding: 15px;

      .nav {
        position: relative;
        height: 100%;

        & li a {
          position: relative;
        }

        & li a::after {
          display: none;
          position: absolute;
          content: "";
          border: 10px solid transparent;
          border-right-color: #fff;
          right: 0;
          top: 50%;
          transform: translate(100%, -50%);
          z-index: 999999;
        }

        & li.son:hover a::after {
          display: block;
        }

        li {
          cursor: pointer;
          position: relative;

          &:hover .sonNav {
            display: flex;
          }

          ul {
            li {
              a {
                &::after {
                  display: none!important;
                }
              }
            }
          }

          .sonNav {
            display: none;
            position: absolute;
            left: 100%;
            z-index: 9999;
            padding-left: 18px;
            top: 0;
            // height: 100%;
            top: 50%;
            transform: translateY(-50%);

            ul {
              background-color: rgba(255, 255, 255, 0.6);
              backdrop-filter: blur(5px);
              box-shadow: -5px 0 10px rgba(0, 0, 0, 0.2),
              1px 0 10px rgba(0, 0, 0, 0.2);
              border-radius: 10px;
              height: 100%;
              width: 120px;

              li span {
                color: #5e6061;
              }

              li .router-link-exact-active span,
              li:hover a span {
                color: var(--main-c);
              }

              li .router-link-exact-active {
                background-color: #eff4fd;
              }

              li {
                a {
                  &::after {
                    display: none;
                  }
                }
              }
            }
          }

          a {
            color: #5e6061;
            padding: 8px 15px;
            margin: 5px 0;
            border-radius: 4px;
            display: flex;
            align-items: center;
          }

          .iconfont {
            font-size: 24px;
            margin-right: 5px;
          }

          span {
            font-size: 18px;
          }

          .router-link-exact-active,
          &:hover a {
            color: var(--main-c);
          }

          .router-link-exact-active {
            background-color: #eff4fd;
          }
        }
      }
    }

    .container_box {
      flex: 1;
      margin-left: 20px;
      overflow: hidden;
    }
  }
}

@media screen and (max-width: 720px) {
  .home header .logo {
    h1 {
      font-size: 18px;
    }

    img {
      width: 30px;
    }
  }

  .home header {
    padding: 10px;

    .right {
      .menu_box {
        display: flex;
      }

      .notice {
        display: none;
      }

      .user {
        margin-left: 10px;

        &::after {
          margin-left: 5px;
        }

        .text {
          .card {
            display: none;
          }

          .name {
            font-size: 16px;
          }
        }
      }
    }
  }

  .home {
    .container {
      nav {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 50%;
        height: 100vh;
        z-index: 999;
        background: #fff;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);

        &.navShow {
          display: flex;
        }
      }

      .container_box {
        margin-left: 0 !important;
      }

      .screen_box {
        flex-wrap: wrap;
      }
    }
  }
}
</style>

<style lang="less">
@media screen and (max-width: 720px) {
  .home {
    .container {
      nav {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 50%;
        height: 100vh;
        z-index: 999;
        background: #fff;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
      }

      .container_box {
        margin-left: 0 !important;
      }

      .screen_box {
        flex-wrap: wrap;
      }
    }
  }

  .contact .screen_box .right,
  .contact .screen_box {
    gap: 10px;
    flex-wrap: wrap;
  }

  .el-table__body-wrapper tr td.el-table-fixed-column--left,
  .el-table__body-wrapper tr td.el-table-fixed-column--right,
  .el-table__body-wrapper tr th.el-table-fixed-column--left,
  .el-table__body-wrapper tr th.el-table-fixed-column--right,
  .el-table__footer-wrapper tr td.el-table-fixed-column--left,
  .el-table__footer-wrapper tr td.el-table-fixed-column--right,
  .el-table__footer-wrapper tr th.el-table-fixed-column--left,
  .el-table__footer-wrapper tr th.el-table-fixed-column--right,
  .el-table__header-wrapper tr td.el-table-fixed-column--left,
  .el-table__header-wrapper tr td.el-table-fixed-column--right,
  .el-table__header-wrapper tr th.el-table-fixed-column--left,
  .el-table__header-wrapper tr th.el-table-fixed-column--right {
    position: static !important;
  }

  .el-dialog {
    width: 98%;
    margin-top: 0;
  }

  .el-form-item {
    flex-direction: column;
  }

  .el-form-item__label {
    justify-content: start;
  }

  .el-dialog__header {
    padding: 0 !important;
  }

  .el-table__body {
    max-width: 720px;
    width: 720px !important;
  }
}
</style>